
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ActionHandler } from '@app/core/components/actions/action.handler';
import { EditarAction } from './master-editar-search-user.action';

@Injectable()
export class MasterSearchUserActions {
    constructor(
        private actionHandler: ActionHandler,
        
            private editarAction: EditarAction
            
        
    ) {}


    editar(context): Observable<any> {
        return this.actionHandler.perform(this.editarAction, context);
    }


}